import axios, { AxiosResponse } from 'axios';
import authHeader from '@/services/auth-header';
import { SALES_ORDERS_ENDPOINT } from '@/constants/endpoints';
import { SalesOrderDTO, SalesOrderFilters, CreateSalesOrderPayload, CreatedSalesOrderDTO } from '@/dto/sales/orders/SalesOrderDTO';
import Page from "@/dto/taxation/Page";

export default new class SalesOrderService {
    public getOrders(filters: SalesOrderFilters = {}): Promise<AxiosResponse<Page<SalesOrderDTO>>> {
        return axios.get<Page<SalesOrderDTO>>(SALES_ORDERS_ENDPOINT, {
            headers: authHeader(),
            params: filters
        });
    }

    public createOrder(payload: CreateSalesOrderPayload): Promise<AxiosResponse<CreatedSalesOrderDTO>> {
        return axios.post<CreatedSalesOrderDTO>(SALES_ORDERS_ENDPOINT, payload, { headers: authHeader() });
    }

    public getOrderById(id: number): Promise<AxiosResponse<SalesOrderDTO>> {
        return axios.get<SalesOrderDTO>(`${SALES_ORDERS_ENDPOINT}/${id}`, { headers: authHeader() });
    }
}
